"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.favouritesProviderActions = exports.initialState = void 0;
const toolkit_1 = require("../../utils/@reduxjs/toolkit");
const api_1 = require("../../utils/api");
const slices_1 = require("../../utils/@reduxjs/slices");
const REDUCER_KEY = 'favouritesProvider';
// The initial state of the FavouritesProvider container
exports.initialState = (0, slices_1.getPreloadedState)(REDUCER_KEY, {
    favouriteEvents: {
        entriesIds: [],
        fetchItems: api_1.requestInitialState,
        createItem: api_1.requestInitialState,
        deleteItem: api_1.requestInitialState,
        deleteItems: api_1.requestInitialState,
    },
});
const eventsProviderSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        /*
        Events
         */
        fetchFavouriteEventsIds(state) {
            state.favouriteEvents.fetchItems.loading = true;
            state.favouriteEvents.fetchItems.error = null;
        },
        fetchFavouriteEventsIdsSuccess(state, action) {
            state.favouriteEvents.entriesIds = action.payload.eventIds;
            state.favouriteEvents.fetchItems.loading = false;
            state.favouriteEvents.fetchItems.error = null;
        },
        fetchFavouriteEventsIdsError(state, action) {
            state.favouriteEvents.fetchItems.loading = false;
            state.favouriteEvents.fetchItems.error = action.payload;
        },
        createFavouriteEvent(state, action) {
            state.favouriteEvents.createItem.loading = true;
            state.favouriteEvents.createItem.error = null;
            state.favouriteEvents.entriesIds = [
                ...state.favouriteEvents.entriesIds,
                action.payload.eventId,
            ]; // Marking event as "Favourite" before actual response to improve UX
        },
        createFavouriteEventSuccess(state) {
            state.favouriteEvents.createItem.loading = false;
            state.favouriteEvents.createItem.error = null;
        },
        createFavouriteEventError(state, action) {
            const { errorData, reqData } = action.payload;
            state.favouriteEvents.createItem.loading = false;
            state.favouriteEvents.createItem.error = errorData;
            state.favouriteEvents.entriesIds =
                state.favouriteEvents.entriesIds.filter((eventId) => eventId !== reqData.eventId); // To handle errors
        },
        deleteFavouriteEvent(state, action) {
            state.favouriteEvents.deleteItem.loading = true;
            state.favouriteEvents.deleteItem.error = null;
            state.favouriteEvents.entriesIds =
                state.favouriteEvents.entriesIds.filter((eventId) => eventId !== action.payload.eventId); // Marking event as "Not Favourite" before actual response to improve UX
        },
        deleteFavouriteEventSuccess(state) {
            state.favouriteEvents.deleteItem.loading = false;
            state.favouriteEvents.deleteItem.error = null;
        },
        deleteFavouriteEventError(state, action) {
            const { errorData, reqData } = action.payload;
            state.favouriteEvents.deleteItem.loading = false;
            state.favouriteEvents.deleteItem.error = errorData;
            state.favouriteEvents.entriesIds = [
                ...state.favouriteEvents.entriesIds,
                reqData.eventId,
            ]; // To handle errors
        },
        deleteFavouriteEventsByIds(state, action) {
            state.favouriteEvents.deleteItem.loading = true;
            state.favouriteEvents.deleteItem.error = null;
            state.favouriteEvents.entriesIds =
                state.favouriteEvents.entriesIds.filter((id) => !action.payload.eventIds.includes(id));
            // Marking event as "Not Favourite" before actual response to improve UX
        },
        deleteFavouriteEventsByIdsSuccess(state) {
            state.favouriteEvents.deleteItem.loading = false;
            state.favouriteEvents.deleteItem.error = null;
        },
        deleteFavouriteEventsByIdsError(state, action) {
            const { errorData, reqData } = action.payload;
            state.favouriteEvents.deleteItem.loading = false;
            state.favouriteEvents.deleteItem.error = errorData;
            state.favouriteEvents.entriesIds = [
                ...state.favouriteEvents.entriesIds,
                ...reqData.eventIds,
            ]; // To handle errors
        },
        deleteFavouriteEvents(state) {
            state.favouriteEvents.deleteItem.loading = true;
            state.favouriteEvents.deleteItem.error = null;
            state.favouriteEvents.entriesIds = [];
        },
        deleteFavouriteEventsSuccess(state) {
            state.favouriteEvents.deleteItem.loading = false;
            state.favouriteEvents.deleteItem.error = null;
        },
        deleteFavouriteEventsError(state, action) {
            const { errorData } = action.payload;
            state.favouriteEvents.deleteItem.loading = false;
            state.favouriteEvents.deleteItem.error = errorData;
        },
    },
});
exports.favouritesProviderActions = eventsProviderSlice.actions, exports.reducer = eventsProviderSlice.reducer, exports.sliceKey = eventsProviderSlice.name;
//# sourceMappingURL=slice.js.map